// @ts-nocheck
import _ from 'lodash';
import { useState, useMemo, useEffect, useCallback } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router';
import Alert, { AlertProps } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import qs from 'query-string';
import {
  GridColDef,
  GridRowModesModel,
  GridRowEditStopParams,
  GridRowModes,
  GridRowId,
  GridRowParams,
  GridFilterModel,
  GridSelectionModel,
  GridSortModel,
  GridLinkOperator,
} from '@mui/x-data-grid-pro';
import { AutoCompleteItem } from 'types/api/Common/AutoCompleteTypes';
import { CustomDataTable } from 'components/DatatableComponent';

import {
  DisplayTableParams,
  useUpsertDisplayTable,
  useUpdateDisplayData,
  useDeleteDisplayData,
  useDataInputDownloadImportTemplate,
  useGetCurrentImportActivity,
  useGetDataInputImportHistory,
  useGetDisplayTableSettingPanel,
} from 'services/v1/Tenant/AROKMS/DisplayTableService';
import {
  useDisplayTableV2,
  usePrefetchDisplayTableV2,
} from 'services/v2/Tenant/AROKMS/DisplayTableService';
import {
  areDisplayTableV2FilterItemsEqual,
  areDisplayTableV2SortModelsEqual,
  getInitialDisplayTableV2HierarchyFilters,
  getDisplayTableV2PrefetchPages,
  shouldApplyDisplayTableV2HierarchyFilters,
} from 'services/v2/Tenant/AROKMS/displayTableV2Adapter';
import { DataInputImportActivityStatus, DynamicDataItem } from 'types/api/Tenant/AROKMS/DisplayTableTypes';
import { AxiosDefaultErrorEntity } from 'types';
import { RulesImplementation } from 'config/RulesImplementation/rulesMapping';
import { convertRuleTypeParamsToSnakeCase } from 'utils/String';
import { renderTextInputEditCell } from 'components/DatatableComponent/CustomTextInput';
import { getColumnDataType } from 'config/RulesImplementation/dataTypeMapping';
import { convertObjectToValue } from 'utils/Object';
import { enUS } from '@mui/x-data-grid';

import eventEmitter, { EVENT_EMITTER_KEYS } from 'utils/EventEmitter';
import ModalDeleteComponent, { ModalDeleteState } from 'components/ModalComponent/ModalDeleteComponent';
import { getErrorMessage, getErrorTitle } from 'utils/Error';
import { ButtonRecordEdit } from '../DataInput/components/ButtonRecordEdit';
import {
  EVENT_SYNC_DATA_SOURCE_CONFIG_STATUS,
  LAYOUT_TABLE_VIEW_TYPE,
  SUBJECT_CATEGORY,
  SUBJECT_TYPE,
} from 'constant/DataInputConstant';
import { serializeDataInputPayload } from '../DataInput/utils/serialiazePayload';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store';
import { checkAccess } from 'routes/PrivateRoute';
import { ROLES } from 'constant/PermissonConstant';
import { DASHBOARD_VIEW_MODE } from 'constant/DashboardTypeConstant';
import {
  generateBreadCumbItemsV2,
  TenantHomeDashboardNavigationBar,
} from 'components/LayoutComponent/VerticalLayout/HeaderBar';
import { PATH_CONSTANT } from 'constant/PathConstant';
import { useSearchParams } from 'react-router-dom';
import { useGetSubjectDetails } from 'services/v1/SystemTenant/AROKMS/SubjectService';
import { useSubjectProcedureDetails } from 'services/v1/SystemTenant/AROKMS/SubjectProcedureService';
import { setHomeNavigationState } from 'store/reducer/homeReducer';
import { ModalDataInputCustomRule } from '../DataInput/components/ModalCustomRule';
import { DataInputSettingPanel } from '../DataInput/components/DataInputSettingPanel';
import { DataInputTableOptions, EventTableOptions } from 'components/ButtonComponent/ButtonTableOptions';
import { SystemStatusBasedAccessProvider } from 'components/RBAC/SystemStatusBasedAccessProvider';
import { downloadFileFromURL, getFileName } from 'utils/DownloadFIle';
import { ModalImportDataInput } from '../DataInput/components/ModalImportDataInput';
import { ModalDataImportNotification } from '../DataInput/components/ModalDataImportNotification';
import { ModalImportDataHistory } from '../DataInput/components/ModalImportDataHistory';
import { isImportingData } from '../DataInput/utils/fileImport';
import { RULE_DATA_TYPE_DATE_TIME } from 'constant/RuleConstant';
import { ModalAssociateFunction } from '../DataInput/components/ModalAssociateFunction';
import { SUBJECT_PROCEDURE_ALLOW_ACTIONS } from 'constant/SubjectConstant';

import { Box } from '@mui/material';
import { AnimatedPage } from 'components/AnimatedPage';
import { getPageAnimationByRefNavigation } from 'utils/Animation';
import { NAVIGATION_COMPONENT_TYPE } from 'constant/NavigationConstant';
import { useGetBreadcumbItems } from 'services/v1/Common/NavBarMenuService';
import { ModalConnectDataChannel } from 'pages/Tenant/AROEvent/Event/components/DataChannel/ModalConnectDataChannel';
import { ModalMappingColumnState } from 'pages/Tenant/AROEvent/Event';
import { useGetLastSyncHistory } from 'services/v1/Tenant/AROEvent/EventDataSourceService';
import { ModalTableAnalytic } from '../TableAnalytic/components/ModalTableAnalytic';
import { FormTableAnalyticParameter } from 'components/ButtonComponent/ButtonTableAnalytic';
import { ModalDisplayAttachments } from '../DataInput/components/ModalDisplayAttachment';

const myCustomLocale = {
  ...enUS,
  dataGrid: {
    ...enUS.dataGrid,
    filterOperatorDropdownFilter: 'contains',
  },
};

interface OptionItem {
  value: string | number;
  label: string;
}

const panelStyle = {
  transform: 'translate3d(704px, 140.667px, 0px) !important',

  '& .MuiDataGrid-panelFooter': {
    display: 'none',
  },
};

const modalDeleteStateInitial: ModalDeleteState = {
  message: '',
  isError: false,
  errorMessage: null,
  open: false,
};

const initialModalAnalyticState = {
  open: false,
  rowTableDefinitionId: null,
  columnTableDefinitiId: null,
  dataTableDefinitionId: null,
};

const DATA_INPUT_V2_DEFAULT_PAGE_SIZE = 20;
const DATA_INPUT_V2_PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];

export default function DataInputV2Page() {
  const { subjectId } = useParams<{ subjectId: string }>();
  const [searchParams] = useSearchParams();
  const procedureId = searchParams.get('procedureId') || '';

  return <DataInputV2PageContent key={`${subjectId}:${procedureId}`} />;
}

function DataInputV2PageContent() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const authReducer = useSelector((state: RootState) => state.auth);
  const { subjectId } = useParams<{ subjectId: string }>();
  const { data: subjectDetails } = useGetSubjectDetails(subjectId);
  const existingSearchParams = qs.parse(location.search);
  const navigationRef = searchParams.get('ref');
  const procedureId = searchParams.get('procedureId') || undefined;
  const pageSearchParam = Number(searchParams.get('page'));
  const sizeSearchParam = Number(searchParams.get('size'));
  const requestedPage = Number.isInteger(pageSearchParam) && pageSearchParam > 0 ? pageSearchParam : 1;
  const requestedPageSize = DATA_INPUT_V2_PAGE_SIZE_OPTIONS.includes(sizeSearchParam)
    ? sizeSearchParam
    : DATA_INPUT_V2_DEFAULT_PAGE_SIZE;
  const { data: breadCrumbItems } = useGetBreadcumbItems(
    procedureId ? procedureId : subjectId,
    procedureId ? NAVIGATION_COMPONENT_TYPE.SUBJECT_PROCEDURE : NAVIGATION_COMPONENT_TYPE.SUBJECT
  );
  const { data: procedureDetails } = useSubjectProcedureDetails(procedureId);

  const [showModalImportNotification, setShowModalImportNotification] = useState<boolean>(false);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});
  const [showCustomRuleModal, setShowCustomRuleModal] = useState<boolean>(false);
  const [showModalImportHistory, setShowModalImportHistory] = useState<boolean>(false);
  const [showModalAssociateFunction, setShowModalAssociateFunction] = useState<boolean>(false);
  const [importActivityStatus, setImportActivityStatus] = useState<DataInputImportActivityStatus | null>(null);
  const [showModalTableAnalytic, setShowModalTableAnalytic] = useState<{
    open: boolean;
    parameterValue?: FormTableAnalyticParameter;
  }>(initialModalAnalyticState);
  const [selectedFilterOptions, setSelectedFilterOptions] = useState<{ [key: string]: string }>({});
  const [isHierarchyInitialized, setIsHierarchyInitialized] = useState(false);
  const [modalMappingEventDataSource, setModalMappingEventDataSource] = useState<ModalMappingColumnState>(false);
  const [modalImportData, setModalImportData] = useState<ModalDataInputState | null>(null);
  const [modalAttachment, setModalAttachment] = useState<{
    visible: boolean;
    objectIds: string[];
    fieldLabel: string;
  }>({
    visible: false,
    objectIds: [],
    fieldLabel: '',
  });
  const [rowData, setRowData] = useState<DynamicDataItem[]>([]);
  const [selectedSubjectOption, setSelectedSubjectOption] = useState<AutoCompleteItem>({ label: '', value: '' });
  const [initialOption] = useState<OptionItem | null>(null);
  const [modalDeleteState, setModalDeleteState] = useState<ModalDeleteState>(modalDeleteStateInitial);
  const [filter, setFilter] = useState<DisplayTableParams>({
    page: requestedPage,
    size: requestedPageSize,
    filterValue: '',
    sortBy: undefined,
    sortType: 'asc',
    filterOperator: 'contains',
    filterColumn: undefined,
    subjectId: undefined,
  });
  const [v2Filters, setV2Filters] = useState<GridFilterModel['items']>([]);
  const [v2Sort, setV2Sort] = useState<GridSortModel>([]);
  const [v2ColumnDataTypes, setV2ColumnDataTypes] = useState<Record<string, string>>({});
  const [snackbar, setSnackbar] = useState<Pick<AlertProps, 'children' | 'severity'> | null>(null);
  const [muiDataTableKey, setMuiDataTableKey] = useState<number>(0);
  const [selectedDataID, setSelectedDataID] = useState<GridRowId[]>([]);
  const [isConnectedToDataSource, setIsConnectedToDataSource] = useState<boolean>(false);
  useEffect(() => {
    setFilter((previousFilter) => {
      if (previousFilter.page === requestedPage && previousFilter.size === requestedPageSize) {
        return previousFilter;
      }
      return {
        ...previousFilter,
        page: requestedPage,
        size: requestedPageSize,
      };
    });
  }, [requestedPage, requestedPageSize]);
  const displayTableFilter = useMemo(
    () => ({
      ...filter,
      subjectId,
      procedureId,
      filters: v2Filters,
      sort: v2Sort,
      columnDataTypes: v2ColumnDataTypes,
    }),
    [filter, procedureId, subjectId, v2ColumnDataTypes, v2Filters, v2Sort]
  );
  const {
    data: tableSettingPanel,
    isSuccess: isHierarchyOptionsSuccess,
    isFetching: isFetchingHierarchyOptions,
    isError: isHierarchyOptionsError,
    error: hierarchyOptionsError,
  } = useGetDisplayTableSettingPanel(subjectId);
  const initialHierarchyFilters = useMemo(
    () =>
      getInitialDisplayTableV2HierarchyFilters(
        tableSettingPanel?.data ?? [],
        (tableDefinitionId) => searchParams.get(tableDefinitionId)
      ),
    [searchParams, tableSettingPanel?.data]
  );
  useEffect(() => {
    if (isHierarchyInitialized || !isHierarchyOptionsSuccess || isFetchingHierarchyOptions) return;

    setSelectedFilterOptions(initialHierarchyFilters);
    setIsHierarchyInitialized(true);
  }, [
    initialHierarchyFilters,
    isFetchingHierarchyOptions,
    isHierarchyInitialized,
    isHierarchyOptionsSuccess,
  ]);
  const {
    data: dataRecord,
    isLoading: isLoadingTable,
    isFetching: isFetchingTable,
    refetch: refetchDataRecord,
    isError,
    error,
  } = useDisplayTableV2(displayTableFilter, selectedFilterOptions, isHierarchyInitialized);
  const prefetchDisplayTableV2 = usePrefetchDisplayTableV2();
  const displayTableError = hierarchyOptionsError || error;
  const isDisplayTableError = isHierarchyOptionsError || isError;
  const isCurrentPageLoading =
    (!isHierarchyInitialized && !isHierarchyOptionsError) || isLoadingTable || isFetchingTable;
  const refetchInitializedDataRecord = useCallback(() => {
    if (!isHierarchyInitialized) return;

    void refetchDataRecord();
  }, [isHierarchyInitialized, refetchDataRecord]);
  const { data: lastSyncEventData } = useGetLastSyncHistory(subjectId, 0);

  const { data: importActivity } = useGetCurrentImportActivity(subjectId, {
    refetchInterval: isImportingData(importActivityStatus) ? 5000 : false,
  });

  const { refetch: refetchImportHistory } = useGetDataInputImportHistory(subjectId);

  const { mutate: downloadImportTemplate } = useDataInputDownloadImportTemplate();

  const { mutate: upsertData } = useUpsertDisplayTable({ subjectId });
  const { mutate: deleteData } = useDeleteDisplayData({ subjectId });
  const { mutate: editData } = useUpdateDisplayData({ subjectId });

  const isViewOnly =
    authReducer.dashboardViewMode === DASHBOARD_VIEW_MODE.VIEW_ONLY ||
    selectedSubjectOption?.type === SUBJECT_TYPE.VIEW;

  const isEditOnly = useMemo(() => {
    return procedureDetails?.data?.allowAction === SUBJECT_PROCEDURE_ALLOW_ACTIONS.UPDATE_ONLY.toString();
  }, [procedureDetails?.data]);

  const isInsertOnly = useMemo(() => {
    return procedureDetails?.data?.allowAction === SUBJECT_PROCEDURE_ALLOW_ACTIONS.INSERT_ONLY.toString();
  }, [procedureDetails?.data]);

  const isDataEditable = useMemo(() => {
    if (isInsertOnly) return false;
    if (subjectDetails?.data?.type === SUBJECT_TYPE.VIEW) return false;
    return checkAccess(
      [ROLES.BUILDER, ROLES.ADMIN, ROLES.TESTER, ROLES.SUPPORT, ROLES.PACKAGER],
      authReducer.threadUserAsRole
    );
  }, [authReducer.threadUserAsRole, subjectDetails, isInsertOnly]);

  const columns = useMemo<GridColDef[]>(() => {
    if (dataRecord?.data?.columns) {
      let dynamicColumns = dataRecord?.data?.columns.map((column) => {
        const dataTypeCode = RULE_DATA_TYPE_DATE_TIME.has(column.ruleTypeCode) ? 'TYPE_DATE' : column.dataTypeCode;
        const isV2NumericColumn = ['TYPE_NUMBER', 'TYPE_INTEGER', 'TYPE_PERCENTAGE', 'TYPE_CURRENCY'].includes(
          column.dataTypeCode
        );
        const columnCellColourData = dataRecord?.data?.cellColor?.[column.field];
        const ruleImplementation = RulesImplementation(column, convertRuleTypeParamsToSnakeCase(column.ruleTypeParams));
        return {
          field: column.field,
          type: getColumnDataType(dataTypeCode),
          headerName: column.headerName,
          width: 150,
          align: 'left',
          headerAlign: 'left',
          renderEditCell: (params) =>
            renderTextInputEditCell({
              ...params,
              type: getColumnDataType(column.dataTypeCode),
              isRequired: !column.allowEmpty,
            }),

          ...ruleImplementation,

          editable: column.editable,
          sortable: column.sortable,
          filterable: column.filterable,
          ...(isV2NumericColumn ? { type: 'number' } : {}),

          renderCell: (params: GridRenderCellParams) => {
            if (!ruleImplementation?.renderCell) return undefined;
            if (columnCellColourData) {
              const cellValue = typeof params?.value === 'object' ? params?.value?.label : params.value;
              const cellColor = columnCellColourData?.[cellValue] || null;
              if (cellColor) {
                return (
                  <Box
                    sx={{
                      backgroundColor: cellColor,
                      width: '100%',
                      height: '100%',
                      alignItems: 'center',
                      display: 'flex',
                    }}
                  >
                    {ruleImplementation?.renderCell(params)}
                  </Box>
                );
              }
            }
            return ruleImplementation?.renderCell(params);
          },
        };
      });

      if (!isDataEditable) {
        dynamicColumns = dynamicColumns.map((column) => {
          return {
            ...column,
            editable: false,
          };
        });
      }

      if (dataRecord.data.layoutView === LAYOUT_TABLE_VIEW_TYPE.DEDICATED_PAGE_VIEW && isDataEditable) {
        return [
          {
            field: 'mui_action',
            headerName: 'Edit',
            editable: false,
            width: 30,
            renderCell: (params: GridRowParams) => (
              <SystemStatusBasedAccessProvider>
                <ButtonRecordEdit
                  {...params}
                  subjectId={subjectId}
                  onClick={() => {
                    navigate(
                      `${PATH_CONSTANT.TENANT.KMS.DATA_INPUT_DEDICATED_PAGE_EDIT.replace(
                        ':subjectId',
                        subjectId
                      ).replace(':recordId', params.id as string)}?refBackParam=${encodeURIComponent(
                        window.location.pathname + window.location.search
                      )}&${qs.stringify({
                        procedureId,
                      })}`
                    );
                  }}
                />
              </SystemStatusBasedAccessProvider>
            ),
            filterable: false,
          },
          ...dynamicColumns,
        ];
      }

      return dynamicColumns;
    }

    return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataRecord, selectedSubjectOption, isDataEditable, importActivityStatus, procedureId]);

  const isDedicatedPageLayout = useMemo(() => {
    if (dataRecord?.data?.layoutView === LAYOUT_TABLE_VIEW_TYPE.DEDICATED_PAGE_VIEW) {
      return true;
    }
    return false;
  }, [dataRecord]);

  const breadCrumbs = useMemo(() => {
    return generateBreadCumbItemsV2(breadCrumbItems?.data);
  }, [breadCrumbItems?.data]);

  const isAnyRowEdit = useMemo(() => {
    return Object.values(rowModesModel).some((item) => item.mode === GridRowModes.Edit);
  }, [rowModesModel]);

  const DataMutationSuccessHandlerOption = {
    onSuccess: () => {
      refetchInitializedDataRecord();
      setRowModesModel({});
    },
    onError: (error: AxiosDefaultErrorEntity) => {
      setSnackbar({ children: getErrorMessage(error), severity: 'error' });
      setRowModesModel({});
      refetchInitializedDataRecord();
    },
  };

  const resetPaginationToFirstPage = () => {
    setFilter((previousFilter) =>
      previousFilter.page === 1 ? previousFilter : { ...previousFilter, page: 1 }
    );
    if (requestedPage === 1) return;

    navigate(
      {
        search: qs.stringify({
          ...existingSearchParams,
          procedureId,
          page: 1,
          size: filter.size,
        }),
      },
      { replace: true }
    );
  };

  const handleOnFilter = (params: GridFilterModel) => {
    if (areDisplayTableV2FilterItemsEqual(v2Filters, params.items)) return;

    setV2Filters(params.items);
    resetPaginationToFirstPage();
  };

  const handleOnSort = (sortModel: GridSortModel) => {
    if (areDisplayTableV2SortModelsEqual(v2Sort, sortModel)) return;

    setV2Sort(sortModel);
    resetPaginationToFirstPage();
  };

  const handleCloseSnackbar = () => setSnackbar(null);

  const handleRowEditStop = (params: GridRowEditStopParams) => {
    setRowModesModel({ ...rowModesModel, [params.id]: { mode: GridRowModes.View } });
  };

  const handleEditRowModes = (params: GridRowParams) => {
    return;

    // eslint-disable-next-line no-unreachable
    if (isViewOnly || isAnyRowEdit) return;

    setRowModesModel({ ...rowModesModel, [params.id]: { mode: GridRowModes.Edit } });
  };

  const handleOnClickDeleteButton = () => {
    setModalDeleteState({
      ...modalDeleteState,
      open: true,
      message: `Are you sure you want to delete ${selectedDataID.length} data?`,
    });
  };

  const handleOnSelectionModelChange = (selectedId: GridSelectionModel) => {
    setSelectedDataID(selectedId);
  };

  const handleOnDeleteData = () => {
    if (selectedDataID.length === 0) return;
    deleteData(
      { subjectId, ids: selectedDataID },
      {
        onSuccess: () => {
          setMuiDataTableKey(muiDataTableKey + 1);
          setSelectedDataID([]);
          setModalDeleteState({ open: false, message: '', isError: false, errorMessage: null });
        },

        onError: (error: AxiosDefaultErrorEntity) => {
          setModalDeleteState({
            open: true,
            message: '',
            isError: true,
            errorMessage: getErrorMessage(error),
          });
        },
      }
    );
  };

  const handleCancelInsert = (id: number) => {
    const newRows = rowData.filter((item) => item.id !== id);
    setRowData(newRows);
    setRowModesModel((prev) => {
      const newModel = _.cloneDeep(prev);
      delete newModel[id];
      return newModel;
    });
  };

  const handleProcessRowUpdate = (data: DynamicDataItem, oldData: DynamicDataItem) => {
    // If old row data is equal to new row data, then do nothing
    // (no need to update just return the data, because nothing changed)
    const { isNew, ...payloadData } = data;

    if (_.isEqual(convertObjectToValue(payloadData, 'label'), oldData)) return oldData;
    // otherwise, update the row data
    else {
      // check is empty from data and check to column whether is nullable
      const isDataEmpty = Object.keys(_.omit(data, ['id', 'isNew'])).every((key) => {
        return !data[key];
      });

      const omitData = _.omit(data, ['id', 'isNew']);
      const omitDataKeys = Object.keys(omitData);

      let emptyNotAllowedKeys = [];

      omitDataKeys.forEach((key) => {
        const column = dataRecord?.data.columns.find((item) => item.field === key);

        if (column) {
          const dataEmpty = data[key] === undefined || data[key] === null || data[key] === '';

          if ((column.allowEmpty === true || column.readOnlyColumn === true) && dataEmpty) {
            // Not a problem, continue to next key.
          } else if (column.nullable === false && dataEmpty) {
            emptyNotAllowedKeys.push(key); // This is a problem.
          }
        }
      });

      const isAnyDataEmpty = emptyNotAllowedKeys.length > 0;

      const dataWithRuleTypeCode = _.mapValues(payloadData, (value, key) => {
        const column = dataRecord?.data.columns.find((item) => item.field === key);
        if (column) {
          return {
            value,
            ruleTypeCode: column.ruleTypeCode,
            dropdownOptions: column.dropdownOptions,
            readOnlyColumn: column.readOnlyColumn,
          };
        }
        return { value };
      });

      const tableDefinitionIdFromColumn = _.mapValues(_.omit(payloadData, ['id', 'isNew']), (value, key) => {
        const column = dataRecord?.data.columns.find((item) => item.field === key);
        if (column) {
          return column.tableDefinitionId;
        }
      });

      if (isDataEmpty) return handleCancelInsert(data.id);

      if (!isDataEmpty && isAnyDataEmpty) return;

      if (isNew) {
        // if the row is new and not empy, then insert the row to database
        if (!isDataEmpty) {
          const insertPayload = _.omit(serializeDataInputPayload(dataWithRuleTypeCode, authReducer), ['id']);

          upsertData(
            { data: insertPayload, tableDefinitionId: tableDefinitionIdFromColumn },
            DataMutationSuccessHandlerOption
          );

          return { ...data, isNew: false };
        }
      } else {
        const updatePayload = serializeDataInputPayload(dataWithRuleTypeCode, authReducer);
        editData(
          { data: updatePayload, tableDefinitionId: tableDefinitionIdFromColumn },
          DataMutationSuccessHandlerOption
        );
        return data;
      }
    }
  };

  const handleChangePage = (newPage: number) => {
    setFilter({ ...filter, page: newPage + 1 });
    navigate({
      search: qs.stringify({
        ...existingSearchParams,
        ...filter,
        procedureId,
        page: newPage + 1,
      }),
    });
  };

  const handleChangePageSize = (newPageSize: number) => {
    setFilter({ ...filter, size: newPageSize, page: 1 });
    navigate({
      search: qs.stringify({
        ...existingSearchParams,
        ...filter,
        procedureId,
        size: newPageSize,
        page: 1,
      }),
    });
  };
  const handleOnOptionClick = (type: DataInputTableOptions) => {
    if (type === EventTableOptions.CONNECT_DATA_SOURCE) {
      setModalMappingEventDataSource({
        open: true,
        isEdit: false,
        eventDataSourceConfigId: null,
      });
    }
    if (type === EventTableOptions.MODIFY_DATA_SOURCE_CONNECTION) {
      setModalMappingEventDataSource({
        open: true,
        isEdit: true,
        eventDataSourceConfigId: lastSyncEventData?.data?.dataSourceConfig?.id || null,
      });
    }
    if (type === DataInputTableOptions.CUSTOM_RULES) {
      setShowCustomRuleModal(true);
    }
    if (type === DataInputTableOptions.IMPORT_DATA_HISTORY) {
      setShowModalImportHistory(true);
    }

    if (type === DataInputTableOptions.FUNCTION_TRIGGER) {
      setShowModalAssociateFunction(true);
    }
  };

  useEffect(() => {
    if (dataRecord?.data?.data) {
      setRowData(dataRecord?.data?.data);
    }
  }, [dataRecord?.data]);
  useEffect(() => {
    if (dataRecord?.data?.columns) {
      setV2ColumnDataTypes(
        Object.fromEntries(dataRecord.data.columns.map((column) => [column.field, column.dataTypeCode]))
      );
    }
  }, [dataRecord?.data?.columns]);
  useEffect(() => {
    if (!subjectId || !isHierarchyInitialized) return;

    const totalPages =
      dataRecord?.data?.currentPage === filter.page ? dataRecord.data.totalPage : filter.page + 2;

    getDisplayTableV2PrefetchPages(filter.page, totalPages).forEach((page) => {
      void prefetchDisplayTableV2(
        {
          ...displayTableFilter,
          page,
        },
        selectedFilterOptions
      );
    });
  }, [
    dataRecord?.data?.currentPage,
    dataRecord?.data?.totalPage,
    displayTableFilter,
    filter.page,
    isHierarchyInitialized,
    prefetchDisplayTableV2,
    selectedFilterOptions,
    subjectId,
  ]);
  useEffect(() => {
    if (isFetchingTable) {
      setRowData([]);
      setSelectedDataID([]);
    }
  }, [isFetchingTable]);
  useEffect(() => {
    if (isDisplayTableError) setRowData([]);
  }, [isDisplayTableError]);

  useEffect(() => {
    if (subjectId) {
      setMuiDataTableKey(muiDataTableKey + 1);
      setIsConnectedToDataSource(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjectId]);

  useEffect(() => {
    if (subjectDetails?.data) {
      if (subjectDetails.data.category === SUBJECT_CATEGORY.USER_LIST) {
        setIsConnectedToDataSource(true);
      }

      const option = {
        label: subjectDetails?.data?.displayName,
        value: subjectDetails?.data?.id,
      };
      setSelectedSubjectOption(option);
      if (!procedureId) {
        dispatch(
          setHomeNavigationState({
            subject: option,
            event: null,
            cube: null,
            ktree: null,
            view: null,
            'subject-procedure': null,
          })
        );
      } else {
        dispatch(
          setHomeNavigationState({
            subject: option,
            event: null,
            cube: null,
            ktree: null,
            view: null,
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjectDetails?.data, procedureId]);

  useEffect(() => {
    if (!isHierarchyInitialized) return;

    if (isImportingData(importActivity?.data?.status)) {
      setImportActivityStatus(DataInputImportActivityStatus.ON_PROGRESS);
      refetchInitializedDataRecord();
    } else {
      setImportActivityStatus(null);
      refetchImportHistory();
      refetchInitializedDataRecord();
    }
    refetchInitializedDataRecord();
  }, [
    importActivity?.data?.status,
    isHierarchyInitialized,
    refetchInitializedDataRecord,
    refetchImportHistory,
  ]);

  useEffect(() => {
    if (lastSyncEventData?.data) {
      setIsConnectedToDataSource(
        Boolean(
          lastSyncEventData?.data?.dataSourceConfig &&
            lastSyncEventData?.data?.dataSourceConfig.status === EVENT_SYNC_DATA_SOURCE_CONFIG_STATUS.CONNECTED
        )
      );
    }
  }, [lastSyncEventData?.data]);

  const insertButtonText = useMemo(() => {
    if (procedureDetails?.data?.procedureName) return `Add ${procedureDetails?.data?.procedureName}`;
    if (!subjectDetails?.data?.subject) return 'Add New';
    return `Add New ${subjectDetails?.data?.displayName}`;
  }, [subjectDetails?.data, procedureDetails?.data]);

  const handleOnAddDataClick = () => {
    navigate(
      `${PATH_CONSTANT.TENANT.KMS.DATA_INPUT_DEDICATED_PAGE_INSERT.replace(':subjectId', subjectId)}?${qs.stringify({
        subjectId,
        procedureId: procedureDetails?.data?.id || undefined,
      })}`
    );
  };

  const handleOnTemplateClick = (selectedFileType: string) => {
    downloadImportTemplate(
      { subjectId, fileType: selectedFileType },
      {
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));

          downloadFileFromURL(
            url,
            `ImportTemplate_${getFileName(subjectDetails?.data?.displayName, selectedFileType)}`
          );
        },
      }
    );
  };

  const handleOnDisplayTableAnalytic = (data: FormTableAnalyticParameter) => {
    setShowModalTableAnalytic({
      open: true,
      parameterValue: data,
    });
  };

  const handleOnKTreeFilterChange = (selectedFilter: { [key: string]: KTreeNode }) => {
    if (!isHierarchyInitialized) return;

    const filter = Object.keys(selectedFilter).reduce((acc, key) => {
      return { ...acc, [key]: selectedFilter[key].value };
    }, {});

    if (!shouldApplyDisplayTableV2HierarchyFilters(selectedFilterOptions, filter)) return;

    setSelectedFilterOptions(filter);
    resetPaginationToFirstPage();
  };

  const handleOnImportOptionClick = (selectedFileType: string) => {
    setModalImportData({ fileType: selectedFileType, open: true });
  };
  const handleOnImportModalClose = () => {
    setModalImportData(null);
  };

  useEffect(() => {
    if (
      isDataEditable &&
      (importActivity?.data?.status === DataInputImportActivityStatus.FAILED ||
        importActivity?.data?.status === DataInputImportActivityStatus.COMPLETED)
    ) {
      setShowModalImportNotification(true);
    }
  }, [importActivity?.data, isDataEditable]);

  useEffect(() => {
    const handleOnShowAttachmentClick = (data: { visible: boolean; url: string; fieldLabel: string }) => {
      setModalAttachment(data);
    };
    eventEmitter.on(EVENT_EMITTER_KEYS.TRIGGER_SHOW_MODAL_ATTACHMENT, handleOnShowAttachmentClick);

    return () => {
      eventEmitter.off(EVENT_EMITTER_KEYS.TRIGGER_SHOW_MODAL_ATTACHMENT, handleOnShowAttachmentClick);
    };
  }, []);

  return (
    <TenantHomeDashboardNavigationBar error={displayTableError} breadCrumbs={breadCrumbs}>
      <ModalDataImportNotification
        importActivity={importActivity?.data}
        onClose={() => setShowModalImportNotification(false)}
        visible={showModalImportNotification}
        subjectDisplayName={subjectDetails?.data?.displayName}
        subjectId={subjectId}
      />
      <AnimatedPage key={subjectId || 'default-subject'} variants={getPageAnimationByRefNavigation(navigationRef)}>
        <CustomDataTable
          localeText={myCustomLocale.dataGrid}
          key={`custom-data-table-${muiDataTableKey}`}
          initialState={{
            pinnedColumns: {
              left: ['mui_action'],
            },
            pagination: {
              page: 0,
            },
          }}
          isError={isDisplayTableError}
          errorMessage={displayTableError && getErrorMessage(displayTableError)}
          errorTitle={getErrorTitle(displayTableError)}
          loading={
            isCurrentPageLoading ||
            importActivityStatus === DataInputImportActivityStatus.ON_PROGRESS
          }
          rows={rowData}
          columns={columns}
          rowCount={dataRecord?.data.rowCount ?? 0}
          page={filter.page - 1}
          pageSize={filter.size}
          getRowId={(row) => row?.id || 0}
          onPageChange={handleChangePage}
          checkboxSelection={false}
          onPageSizeChange={handleChangePageSize}
          rowModesModel={rowModesModel}
          disableSelectionOnClick
          rowsPerPageOptions={DATA_INPUT_V2_PAGE_SIZE_OPTIONS}
          onSelectionModelChange={handleOnSelectionModelChange}
          processRowUpdate={handleProcessRowUpdate}
          onProcessRowUpdateError={(error) => {
            console.log(error, rowData, rowModesModel);
          }}
          onRowEditStop={handleRowEditStop}
          onRowDoubleClick={handleEditRowModes}
          getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
          experimentalFeatures={{ newEditingApi: true }}
          onFilterModelChange={handleOnFilter}
          filterModel={{ items: v2Filters, linkOperator: GridLinkOperator.And }}
          onSortModelChange={handleOnSort}
          paginationMode='server'
          editMode='row'
          sortingMode='server'
          filterMode='server'
          autoHeight={rowData.length !== 0 && rowData.length > 5}
          columnBuffer={2}
          columnThreshold={2}
          components={{
            Toolbar: DataInputSettingPanel,
          }}
          componentsProps={{
            panel: {
              sx: panelStyle,
            },
            filterPanel: {
              linkOperators: [GridLinkOperator.And],
            },
            toolbar: {
              // @ts-ignore
              viewOnly: isViewOnly || isEditOnly,
              withChipLabel: true,
              onOptionClick: handleOnOptionClick,
              disabled:
                !isHierarchyInitialized ||
                isCurrentPageLoading ||
                rowData.some((item) => item.isNew) ||
                isAnyRowEdit,
              isInserting: rowData.some((item) => item.isNew),
              setRows: setRowData,
              setRowModesModel,
              onDeleteData: handleOnClickDeleteButton,
              options: [],
              initialOption,
              optionValue: selectedSubjectOption,
              onAddDataClick: isDedicatedPageLayout ? () => handleOnAddDataClick() : undefined,
              onButtonTemplateClick: handleOnTemplateClick,
              onImport: handleOnImportOptionClick,
              onButtonTableAnalyticClick: handleOnDisplayTableAnalytic,
              onKTreeFilterChange: handleOnKTreeFilterChange,
              connectedToDataSource: isConnectedToDataSource,
              config: {
                deleteButtonText: 'Delete',
                fieldFocusOnInsert: '',
                insertButtonText,
                insertInitialObject: {
                  ...dataRecord?.data.columnInitialValues,
                  isNew: true,
                },
              },
            },
          }}
        />
      </AnimatedPage>
      {!!snackbar && (
        <Snackbar
          open
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={3000}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}

      <ModalTableAnalytic
        open={showModalTableAnalytic.open}
        onClose={() => setShowModalTableAnalytic(initialModalAnalyticState)}
        subjectId={subjectId}
        parameterValue={showModalTableAnalytic.parameterValue}
      />

      <ModalImportDataInput
        visible={modalImportData?.open}
        subject={subjectDetails?.data}
        onClose={handleOnImportModalClose}
        onCancel={handleOnImportModalClose}
        subjectType='SUBJECT'
        onImportSuccess={handleOnImportModalClose}
      />
      <ModalImportDataHistory
        visible={showModalImportHistory}
        onClose={() => setShowModalImportHistory(false)}
        subjectId={subjectId}
      />

      <ModalAssociateFunction
        visible={showModalAssociateFunction}
        onClose={() => setShowModalAssociateFunction(false)}
        subjectId={subjectId}
      />
      <ModalConnectDataChannel
        open={modalMappingEventDataSource.open}
        isEdit={modalMappingEventDataSource.isEdit}
        eventDataSourceConfigId={modalMappingEventDataSource.eventDataSourceConfigId}
        eventSubject={subjectDetails?.data}
        onClose={() =>
          setModalMappingEventDataSource({
            eventDataSourceConfigId: null,
            isEdit: false,
            open: false,
          })
        }
      />
      <ModalDeleteComponent
        visible={modalDeleteState.open}
        message={modalDeleteState.message}
        isError={modalDeleteState.isError}
        errorMessage={modalDeleteState.errorMessage}
        onApprove={handleOnDeleteData}
        onClose={() => setModalDeleteState(modalDeleteStateInitial)}
        onCancel={() => setModalDeleteState(modalDeleteStateInitial)}
      />
      <ModalDataInputCustomRule
        visible={showCustomRuleModal}
        subjectId={subjectId}
        onClose={() => setShowCustomRuleModal(false)}
      />
      <ModalDisplayAttachments
        fieldLabel={modalAttachment.fieldLabel}
        visible={modalAttachment.visible}
        subjectId={subjectId}
        initialObjectIds={modalAttachment.objectIds}
        onClose={() => {
          setModalAttachment({ visible: false, url: '' });
        }}
      />
    </TenantHomeDashboardNavigationBar>
  );
}
